import React from "react";
import { useTranslation } from "react-i18next";
import Logo from "../header/logo/Logo";
import LinksFooter from "./LinksFooter";
import ChooseLangController from "../../mui/chose_lang/ChooseLangController";
import ButtonUp from "../../mui/button_up/ButtonUp";
import TgLinksFooter from "./TgLinksFooter";
import CopyrightFooter from "./CopyrightFooter";

export default function FooterDesktop() {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="footer__content">
        <div className="footer__content__one">
          <Logo />
          <div className="footer__content__contents">
            <span className="footer__content__contents__title">{t("Contents")}</span>
            <LinksFooter />
          </div>
          <div className="footer__content__controls">
            <ChooseLangController />
            <ButtonUp />
          </div>
        </div>
        {/* <FooterInside /> */}

        <div className="footer__content__three">
          {/* <SocialIcons /> */}
          <TgLinksFooter />
          <CopyrightFooter />
        </div>
      </div>
    </footer>
  );
}
